import React from 'react';
import { Link } from 'react-router-dom';
import SlideInAnimation from '../components/SlideInAnimation/SlideInAnimation';
import SliderNav from '../components/SliderNav/SliderNav';
import LayoutWrapper from '../layout/LayoutWrapper'
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
//import {useState, useEffect} from 'react';
import Logo1 from '../assets/images/logo.svg';

export const useMobileDetect = () => {

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    return { isMobile };
}

function ScrollToAnchor() {
    const location = useLocation();
    const lastHash = useRef('');

    // listen to location change using useEffect with location as dependency
    // https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen
    useEffect(() => {
        if (location.hash) {
            lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
        }

        if (lastHash.current && document.getElementById(lastHash.current)) {
            setTimeout(() => {
                document
                    .getElementById(lastHash.current)
                    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                lastHash.current = '';
            }, 100);
        }
    }, [location]);

    return null;
}


//export default ScrollToAnchor;

const h1Style = {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'left',
    padding: '10px 2px',
    color: '#9601c8'
}

const h2Style = {
    fontSize: 13,
    fontWeight: 'bold',
    textAlign: 'left',
    padding: '10px 2px'
}

const p1Style = {
    fontSize: 10,
    fontWeight: 'normal',
    textAlign: 'left',
    color: '#585858'
}

const highlightStyle = {
    fontWeight: 'bold',
    color: '#9601c8'
}

const FeatureBox = (props) => {

    return (
        <div style={{ display: 'flex', alignItems: 'center', maxWidth: 300, padding: 10 }}>
            <div>
                <div style={{
                    width: 32, height: 32,
                    //backgroundColor: '#ffeac3', 
                    borderRadius: '5px', margin: 10, backgroundImage: props.icon ? `url('images/${props.icon}')` : null,
                    backgroundPosition: 'top', backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'
                }}>
                </div>
            </div>


            <div style={p1Style}>{props.children}</div>
        </div>
    )
}

const FeatureBoxView = (props) => {
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', borderRadius: 10, alignItems: 'center', maxWidth: 300, minWidth: 250, padding: 10, margin: 10,
            boxShadow: '2px 2px 5px rgba(100,100,100,0.1)', border: '1px dotted #b800f7'
        }}>
            <div>
                <div style={{
                    width: 120, height: 150,
                    //backgroundColor: '#ececec', 
                    margin: 10, backgroundImage: props.icon ? `url('images/${props.icon}')` : null,
                    backgroundPosition: 'top', backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'
                }}>
                </div>
            </div>


            <div style={p1Style}><div style={{ ...h2Style, color: '#b800f7' }}>{props.title}</div>{props.children}</div>
        </div>
    )
}

const ProductBoxView = (props) => {
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', borderRadius: 10, alignItems: 'center', maxWidth: 300, minWidth: 150, padding: 10, margin: 10,
            boxShadow: '2px 2px 5px rgba(100,100,100,0.1)', border: '1px dotted #b800f7', background:'#fbf9ff'
        }}>
            <div>
                <div style={{
                    width: 160, height: 160,
                    //backgroundColor: '#ececec', 
                    margin: 10, backgroundImage: props.icon ? `url('images/${props.icon}')` : null,
                    backgroundPosition: 'top', backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'
                }}>
                </div>
            </div>
            <div style={p1Style}><div style={{ ...h2Style, color: '#b800f7' }}>{props.title}</div>{props.children}</div>
        </div>
    )
}

const PricingViewItem = props => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: 10 }}>
            <span style={{
                ...h1Style, textAlign: 'left', width: 30, background: "url('images/check-icon.svg')",
                backgroundPositionX: 0, backgroundRepeat: 'no-repeat', backgroundSize: '60%'
            }}></span>
            <span style={{ ...p1Style, textAlign: 'left', fontSize: 12 }}>{props.children}</span>
        </div>
    )
}

const pricing_plans = [
    /* {
        name:'Free',
        monthlyCost: 0,
        features:[            
            "Up to 1000 monthly orders",
            "Up to 200 inventory items",
            "Manage up to 2 team members",
            "Basic reporting",
            "Order tracking"
        ]
    },
    {
        name:'Basic',
        monthlyCost: 6000,
        features:[
            "Custom store domain",
            "Up to 10000 monthly orders",
            "Up to 500 inventory items",
            "Manage up to 10 team members",
            "Basic reporting",
            "Order tracking"
        ]
    }, */
    {
        name: 'Premium',
        monthlyCost: null,
        features: [
            "Multiple store domains",
            "Unlimited monthly orders",
            "Unlimited inventory items",
            "Unlimited team members",
            "Advanced reporting",
            "Order tracking"
        ]
    }
]

const testimonials = [
    {
        fullName: 'Chiemezie, Abuja',
        title: "Weekly Buyer for Her Mum’s Diet",
        company: "",
        testimony: "Korafresh has been a blessing for my family. I buy their frozen strawberries every single week for my mum’s diet, and the consistency has been amazing. Fresh, clean, and packed exactly the same way every time. It’s taken the stress out of meal prep, and my mum actually looks forward to them now!",

    },
    {
        fullName: 'Sarah, Abuja',
        title: "Sweet, Tangy, crunchy & Perfectly Freeze-dried",
        company: "",
        testimony: "The freeze dried quality is too good! The strawberries stay firm, fresh, and full of that sweet-tangy taste I absolutely love. I’ve tried others, but nothing compares to Korafresh. These ones actually taste like real strawberries.",

    },
    {
        fullName: 'Kemi, Lagos',
        title: "Smoothies & Baking Made Better",
        company: "",
        testimony: "Korafresh has completely upgraded my smoothies and baking. Their strawberries blend smoothly, no sour aftertaste, no crushed or watery fruits — just fresh, juicy goodness every time. It’s now the only brand I trust.",

    },
    {
        fullName: 'Chinny, Port Harcourt',
        title: "Fit fam lifestyle upgraded",
        company: "",
        testimony: "Staying consistent with my fit-fam lifestyle used to be a struggle, until I found Korafresh. Their strawberries make healthy eating enjoyable, not stressful. It’s become a part of my routine that I actually look forward to.",

    }
]
const PricingBoxView = (props) => {

    const directToMailTo = (e) => {
        window.location.href = 'mailto:info@odanow.net';
        e.preventDefault();
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: 10, borderRadius: 10, padding: 10, border: '1px solid #CECECE', width: 300 }}>
            <div style={{ borderBottom: '1px solid #CECECE', display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', width: '100%' }}>
                <span style={{ ...h1Style, textAlign: 'left', fontSize: 16 }}>{props.name}</span>
                <span style={{ ...h1Style, textAlign: 'left' }}>NGN {props.monthlyCost ?? "--"}<span style={{ ...p1Style, textAlign: 'left' }}>/ month</span></span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: 10 }}>
                {props.features.map(f => <PricingViewItem>{f}</PricingViewItem>)}
            </div>
            <div style={{ padding: 10, width: '100%' }}>
                {/*   <button style={{ padding: '10px 25px', color: 'white', background: '#ef5a29', border: 0, borderRadius: 5, width:'100%', }}>{props.monthlyCost ? 'Get Started' : 'Contact Us'}</button> */}
                <Link
                    onClick={!(props.monthlyCost || props.monthlyCost == 0) && directToMailTo}

                    style={{ padding: '10px 25px', color: 'white', display: 'block', background: '#ef5a29', border: 0, borderRadius: 5, width: '100%', textDecoration: 'none', fontSize: 12 }}
                    to={props.monthlyCost || props.monthlyCost == 0 ? 'https://web.odanow.net' : '#'}>
                    {props.monthlyCost || props.monthlyCost == 0 ? 'Get Started' : 'Contact Us'}
                </Link>

            </div>
        </div>
    )
}

const TestimonyBoxView = (props) => {

    const directToMailTo = (e) => {
        window.location.href = 'mailto:info@odanow.net';
        e.preventDefault();
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: 10, borderRadius: 10, padding: 10, border: '1px solid #CECECE', width: 300 }}>
            <span style={{ ...p1Style, textAlign: 'left', fontWeight: 'bold', fontSize: 13, paddingBottom: 5 }}>{props.title ?? "--"}</span>
            <span style={{ ...p1Style, textAlign: 'left' }}><span style={{ fontSize: 16 }}>“</span>{props.testimony ?? "--"}<span style={{ fontSize: 16 }}>”</span></span>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', width: '100%' }}>

                <span style={{ ...p1Style, textAlign: 'left', fontSize: 12, fontWeight: 'bold', color: '#5f027eff', paddingTop: 5, paddingBottom: 5 }}>- {props.fullName}</span>

            </div>
        </div>
    )
}

const HomePage = (props) => {

    const { isMobile } = useMobileDetect();

    return (
        <div style={{ width: "100%" }}>
            <ScrollToAnchor />
            <div id={"home"} style={{ display: 'flex', background: '#b800f7', position: 'relative', flexDirection: isMobile ? 'column' : 'row', width: '100%', minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'column', color: 'white', maxWidth: 300 }}>
                    <span style={{ ...h1Style, fontSize: 32, color: 'white' }}>Your healthy snack plug!</span>
                    <span style={{ ...p1Style, color: 'white', fontSize: 13 }}>Korafresh is a one-stop shop for delicious, high-quality fresh strawberry, fresh frozen strawberry fruit, freeze dried strawberry snack and other plant based freeze dried healthy snack!</span>
                    <div style={{ padding: 30 }}>
                        <Link style={{ padding: '10px 25px', background: '#ffffff', color: '#b800f7', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                    </div>
                </div>
                <div style={{ bottom: -20, width: isMobile ? 250 : 400, height: isMobile ? 250 : 400, background: "url('images/strawberry-banner-image-01.png')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                </div>

            </div>
            <div style={{ height: isMobile ? 60 : 140, backgroundColor: '#b800f7', backgroundImage: "url('images/banner-seperator.svg')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

            </div>
            <div id={"home"} style={{ display: 'flex', position: 'relative', flexDirection: 'column', width: '100%', minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>

                <div style={{ width: isMobile ? 200 : 300, height: isMobile ? 200 : 300, background: "url('images/main-collection.png')", backgroundPosition: 'top', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}>

                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: '80%', maxWidth: 700 }}>
                    <span style={{ ...p1Style, fontSize: 16, padding: 10 }}>
                        <span style={highlightStyle}>Kora Fresh</span> has a large selection of  <span style={highlightStyle}>fresh</span>,  <span style={highlightStyle}>frozen</span>  and  <span style={highlightStyle}>freeze dried Strawberry</span> varieties to suit every taste, from sweet and juicy to tart and tangy. We've got you covered if you're looking for fresh strawberries for snacking, adding to your bowl of cereal or parfait, baking, or making homemade jams and preserves.
                    </span>
                    <div style={{ padding: 20 }}>
                        <Link style={{ padding: '10px 25px', background: '#b800f7', color: '#ffffff', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                    </div>
                </div>

            </div>
            <div id="features" style={{ display: 'flex', position: 'relative', width: '100%', minHeight: 50, paddingTop: 20, alignItems: 'center', justifyContent: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 500 }}>
                    <span style={{ ...h1Style, textAlign: 'center', fontSize:16 }}>In addition to our fresh and frozen strawberries, we offer a range of other freeze dried fruits for your enjoyment including:</span>
                </div>

            </div>
            <div style={{
                display: 'flex',
                position: 'relative',
                width: '100%',
                flexDirection:'column',
                //background:'none', 
                //backgroundImage: "url('images/banner-image-02.png')", 
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: '0%',
                backgroundSize: 'contain',
                minHeight: 100,
                padding: 10,
                alignItems: 'center',
                justifyContent: 'center'
            }}>


                <div style={{ display: 'inline-grid', gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", maxWidth: 800, flexDirection: 'column', width: '80%', margin: 10 }}>
                    <ProductBoxView title={"Mango"} icon={"mango.png"}>
                    </ProductBoxView>
                    <ProductBoxView title={"Pineapple"} icon={"pineapple.png"}>
                    </ProductBoxView>
                    <ProductBoxView title={"Banana"} icon={"banana.png"}>
                    </ProductBoxView>
                </div>

                <div style={{ padding: 20 }}>
                            <Link style={{ padding: '10px 25px', background: '#b800f7', color: '#ffffff', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                        </div>

            </div>

            <div id={"why-us"} style={{ display: 'flex', position: 'relative', flexDirection: isMobile ? 'column' : 'row', width: '100%', minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ background: '#e5d7ff', display: 'flex', position: 'relative', flexDirection: isMobile ? 'column' : 'row', width: '90%', borderRadius: 20, maxWidth: 800, minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>


                    <div style={{ margin: isMobile ? 20 : null, borderRadius: 12, border: isMobile ? '1px dashed #b800f7' : null, width: isMobile ? 300 : 450, height: isMobile ? 300 : 400, background: "url('images/why-choose-us.png')", backgroundPosition: 'top', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}>

                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300 }}>
                        <span style={{ ...h1Style, fontSize: 32 }}>Why choose us?</span>
                        <span style={{ ...p1Style, fontSize: 12 }}>
                            We know that our customers care about the environment like us. For this reason, we employ sustainable farming practices that reduce waste and our carbon footprint. We also make it a point to use recyclable packaging materials whenever possible.
                        </span>
                        <div style={{ padding: 20 }}>
                            <Link style={{ padding: '10px 25px', background: '#b800f7', color: '#ffffff', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                        </div>
                    </div>
                </div>
            </div>


            <div id="features" style={{ display: 'flex', position: 'relative', width: '100%', minHeight: 50, paddingTop: 20, alignItems: 'center', justifyContent: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 500 }}>
                    <span style={{ ...h1Style, textAlign: 'center' }}>Shop Our Collections</span>
                </div>

            </div>
            <div style={{
                display: 'flex',
                position: 'relative',
                width: '100%',
                flexDirection: 'column',
                //background:'none', 
                //backgroundImage: "url('images/banner-image-02.png')", 
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: '0%',
                backgroundSize: 'contain',
                minHeight: 200,
                padding: 10,
                alignItems: 'center',
                justifyContent: 'center'
            }}>


                <div style={{ display: 'inline-grid', gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", maxWidth: 650, flexDirection: 'column', width: '80%', margin: 10 }}>
                    <FeatureBoxView title={"Korafresh Strawberry Jam"} icon={"jam-strawberry.png"}>
                        A rich, all-natural strawberry jam made from handpicked Korafresh berries. Slow-cooked to preserve flavor, it delivers a sweet, tangy spread perfect for bread, pastries, yogurt bowls, and desserts. No artificial flavors — just real strawberries in every spoonful.
                    </FeatureBoxView>
                    <FeatureBoxView title={"Korafresh Fresh Strawberries"} icon={"fresh-strawberry.png"}>
                        Naturally grown on our Nigerian farms, Korafresh strawberries are juicy, vibrant, and packed with antioxidants. Harvested at peak ripeness and delivered fresh, they’re perfect for snacking, baking, smoothies, and healthy meal plans.
                    </FeatureBoxView>
                    <FeatureBoxView title={"Korafresh Frozen Strawberries"} icon={"frozen-strawberry.png"}>
                        Frozen within hours of picking to lock in nutrients and flavor. Korafresh frozen strawberries are convenient, long-lasting, and ideal for smoothies, sauces, desserts, and meal prep — giving you farm-fresh goodness all year round.
                    </FeatureBoxView>
                    <FeatureBoxView title={"Korafresh Freeze-Dried Strawberries"} icon={"freeze-dried-strawberry.png"}>
                        Crisp, light, and intensely flavored, our freeze-dried strawberries are made from 100% real fruit with no added sugar. They retain the taste and nutrients of fresh berries while offering a crunchy, melt-in-your-mouth experience. Perfect for snacking, toppings, kids’ lunchboxes, and healthy cravings on the go
                    </FeatureBoxView>
                </div>

                <div style={{ padding: 20 }}>
                    <Link style={{ padding: '10px 25px', background: '#b800f7', color: '#ffffff', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                </div>

            </div>

            {/* <div style={{ display: 'flex', position: 'relative', flexDirection: isMobile ? 'column' : 'row', width: '100%', minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300, padding: '15px 0px' }}>
                    <span style={h1Style}>Better Customer Experience</span>
                    <span style={p1Style}>With real-time order tracking, customers can see the status of their orders, reducing the number of enquiries and improving the overall customer experience.</span>
                </div>
                <div style={{ width: 300, height: 300, background: "url('images/banner-image-03.png')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                </div>

            </div> */}

            {/* <div style={{ display: 'flex', position: 'relative', flexDirection: isMobile ? 'column-reverse' : 'row', width: '100%', minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>

                <div style={{ width: 300, height: 300, background: "url('images/banner-image-04.png')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                </div>
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300, padding: '15px 0px' }}>
                    <span style={h1Style}>Increased Sales</span>
                    <span style={p1Style}>An OMS can automate upselling and cross-selling opportunities, helping SMEs to increase sales and revenue. Reducing manual errors and increasing efficiency. This saves time and resources, freeing up valuable manpower to focus on other areas of the business.</span>
                </div>


            </div>

            <div style={{ display: 'flex', position: 'relative', flexDirection: isMobile ? 'column' : 'row', width: '100%', minHeight: 300, padding: 0, alignItems: 'center', justifyContent: 'center' }}>


                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300, padding: '15px 0px' }}>
                    <span style={h1Style}>Data Insights</span>
                    <span style={p1Style}>Generates valuable data and insights on customer behavior, sales trends, and inventory levels, enabling SMEs to make data-driven decisions and improve their operations.</span>
                </div>
                <div style={{ width: 300, height: 300, background: "url('images/banner-image-05.png')", backgroundPosition: 'top', backgroundSize: '100%', backgroundRepeat: 'no-repeat' }}>
                </div>

            </div> */}
            <div style={{ display: 'flex', position: 'relative', width: '100%', padding: 0, alignItems:'center', justifyContent: 'center' }}>
            {!isMobile && <div style={{ display: 'flex', position: 'relative', width: '95%', padding: 0, justifyContent: 'center' }}>

                <SliderNav style={{ padding: 0, borderRadius:20,  width: '100%', minHeight: 350 }}>
                    <div className='banner-wrapper-01' style={{ minHeight: 350, width: '100%', background: "url('images/Sales_desktop_2.jpg')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', }}>

                        <Link style={{ padding: '10px 25px', background: '#b800f7', color: '#ffffff', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                    </div>
                    <div className='banner-wrapper-01' style={{ minHeight: 350, width: '100%', background: "url('images/Sales_desktop_1.jpg')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', }}>


                    </div>
                </SliderNav>
            </div>}

            {isMobile && <div style={{ display: 'flex', position: 'relative', width: '100%', padding: 0, justifyContent: 'center' }}>

                <SliderNav style={{ padding: 0, width: '100%', minHeight: 350 }}>
                    <div className='banner-wrapper-01' style={{ minHeight: 350, width: '100%', background: "url('images/Sales_2 mobile.jpg')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', }}>

                        <Link style={{ padding: '10px 25px', background: '#b800f7', color: '#ffffff', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                    </div>
                    <div className='banner-wrapper-01' style={{ minHeight: 350, width: '100%', background: "url('images/Sales_1 Mobile.jpg')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', }}>


                    </div>
                </SliderNav>
            </div>}
            </div>

            {/* <div style={{ display: 'flex', position: 'relative', width: '100%', minHeight: 50, paddingTop: 20, alignItems: 'center', justifyContent: 'center' }}>

            <div id='pricing-plans' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 500 }}>
                <span style={{ ...h1Style, textAlign: 'center' }}>Genuine experiences from our clients.</span>
            </div>

            </div>
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', position: 'relative', width: '100%', minHeight: 50, paddingTop: 20, alignItems: 'center', justifyContent: 'center' }}>

            <PricingBoxView></PricingBoxView>
            <PricingBoxView></PricingBoxView>

            </div>
 */}

            {/** Testimonials */}
            <div style={{ display: 'flex', position: 'relative', width: '100%', minHeight: 50, paddingTop: 20, alignItems: 'center', justifyContent: 'center' }}>

                <div id='pricing-plans' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '80%' }}>
                    <span style={{ ...h1Style, textAlign: 'center', fontSize: 24 }}>What Our Clients Are Saying</span>
                    <span style={p1Style}>Thank you for choosing Kora Fresh for your fruit and vegetable needs. We cannot wait to share our delicious and nutritious products with you!</span>

                </div>

            </div>
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', position: 'relative', width: '100%', minHeight: 50, paddingTop: 20, alignItems: 'center', justifyContent: 'center' }}>

                {testimonials.map(pp => <TestimonyBoxView {...pp}></TestimonyBoxView>)}


            </div>
            <div style={{ display: 'flex', position: 'relative', width: '100%', minHeight: 20, padding: 0, alignItems: 'center', background: '#ffffff', justifyContent: 'center' }}>




            </div>


            {/*<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <div className='info-card-short-text'>
                    Welcome to the world of order management automation! Our platform is designed to streamline and simplify the ordering process for businesses of all sizes. Whether you're a small startup or a large corporation, our platform offers the tools you need to manage your orders efficiently and effectively.

                </div>
                <div style={{ maxWidth: 600, width: '100%', padding: 20, color: '#554433' }}>
                    With our advanced technology, you can easily manage your entire order lifecycle, from receiving orders to shipping them out. Our platform provides real-time updates on the status of your orders, so you never have to worry about missing a step. We also integrate with a variety of shipping carriers and payment providers, so you can get your orders out the door as quickly and smoothly as possible.

                </div>
            </div>
            <div className='banner-wrapper-01' style={{ fontWeight: 'bold', fontSize: 30 }}>
                Key Features
    </div>*/}
            {/*<div style={{ display: 'flex', position: 'relative', paddingBottom: 50, justifyContent: 'center' }}>
                <SliderNav style={{ maxWidth: 800, padding: 20, width: '100%' }}>
                    <div className='info-card-wrapper' style={{ display: 'flex', }}>
                        <div className='info-card-numbering' style={{ background: 'orange', width: 200, minHeight: 200 }}>1</div>
                        <div style={{ flexGrow: 1, background: '#EEEEEE', textAlign: 'left', padding: 10, }}>
                            <div style={{ fontSize: 20, padding: '20px 2px', fontWeight: 'bold' }}>Collaborate with ease</div>
                            Our system allows you to share order information and status updates with team members in real-time, improving communication and reducing the risk of errors.

                        </div>
                    </div>
                    <div className='info-card-wrapper' style={{ display: 'flex', }}>
                        <div className='info-card-numbering' style={{ background: 'orange', width: 200, minHeight: 200 }}>2</div>
                        <div style={{ flexGrow: 1, background: '#EEEEEE', textAlign: 'left', padding: 10, }}>

                            <div style={{ fontSize: 20, padding: '20px 2px', fontWeight: 'bold' }}>Track orders</div>
                            You and your customers can keep tabs on your orders from start to finish with real-time updates and detailed tracking information.

                        </div>
                    </div>
                    <div className='info-card-wrapper' style={{ display: 'flex', }}>
                        <div className='info-card-numbering' style={{ background: 'orange', width: 200, minHeight: 200 }}>3</div>
                        <div style={{ flexGrow: 1, background: '#EEEEEE', textAlign: 'left', padding: 10, }}>
                            <div style={{ fontSize: 20, padding: '20px 2px', fontWeight: 'bold' }}>Manage your customers</div>
                            Organize customer information, including contact details and order history, all in one place.

                        </div>
                    </div>
                    <div className='info-card-wrapper' style={{ display: 'flex', }}>
                        <div className='info-card-numbering' style={{ background: 'orange', width: 200, minHeight: 200 }}>4</div>
                        <div style={{ flexGrow: 1, background: '#EEEEEE', textAlign: 'left', padding: 10, }}>

                            <div style={{ fontSize: 20, padding: '20px 2px', fontWeight: 'bold' }}>Streamline invoicing</div>
                            Easily generate and manage invoices for your orders, saving time and reducing the risk of errors.

                        </div>

                    </div>
                    <div className='info-card-wrapper' style={{ display: 'flex', }}>
                        <div className='info-card-numbering' style={{ background: 'orange', width: 200, minHeight: 200 }}>5</div>
                        <div style={{ flexGrow: 1, background: '#EEEEEE', textAlign: 'left', padding: 10, }}>
                            <div style={{ fontSize: 20, padding: '20px 2px', fontWeight: 'bold' }}>Stay on top of notifications</div>
                            Receive real-time notifications for important updates, such as order confirmations and shipping updates, ensuring you never miss a beat.

                        </div>
                    </div>
                </SliderNav>
    </div>*/}
            <div style={{
                height: isMobile ? 36 : 42,
                backgroundColor: '#ffffff',
                //transform:'scaleY(1)', 
                backgroundImage: "url('images/footer-seperator.svg')",
                backgroundPosition: '0 2px',//'bottom', 
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>

            </div>
            <div style={{ background: '#b800f7', display: 'flex', justifyContent: 'center', width: '100%' }}>
                <div style={{
                    display: 'flex',
                    position: 'relative',
                    width: '100%',
                    maxWidth: 800,
                    background: '#b800f7',
                    //backgroundImage: "url('images/footer-banner-image.png')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionX: '100%',
                    backgroundSize: 'contain',
                    minHeight: 200,
                    //padding: 10,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                }}>

                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: 10, maxWidth: 300 }}>
                        <span style={{ ...h1Style, color: 'white', fontSize: 16 }}>Your one-stop shop for delicious, high-quality fruits and veggies!</span>
                        {/* <span style={{ ...p1Style, color: 'white' }}>Our platform is designed to streamline and simplify the ordering process for businesses of all sizes.</span>
                     */}<div style={{ padding: 30 }}>

                            <Link style={{ padding: '10px 25px', background: '#ffffff', color: '#b800f7', border: 0, borderRadius: 20, textDecoration: 'none', fontWeight: 'bold', fontSize: 12 }} to={'https://korafresh.odanow.store'}>Shop Now!</Link>

                        </div>
                    </div>
                    <img src={Logo1} style={{ height: isMobile ? 46 : 70, margin: isMobile ? 0 : 20, fontFamily: 'Dancing Script' }} alt="logo" />
                    {/* <div style={{ display:'flex', justifyContent:'flex-end'}}>
                <img style={{width:isMobile ? '90%' : 400,}} src={'images/footer-banner-image.png'}/> 
                </div>*/}

                </div>
            </div>



        </div>
    )
}

export default LayoutWrapper(HomePage, { showNavigationBar: true, showSideMenu: true });